// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mysa-map .vue-map{border-radius:30px}@media screen and (max-width:1365px){.mysa-map .vue-map-container.google-map{height:421px!important}}@media screen and (max-width:1023px){.mysa-map .vue-map-container.google-map{height:405px!important}}@media screen and (max-width:767px){.mysa-map .vue-map-container.google-map{height:200px!important}.mysa-map .vue-map{border-radius:10px}}", ""]);
// Exports
module.exports = exports;
